// TODO Refactor
$(function () {
    // Get search parameters
    let searchParams = new URLSearchParams(window.location.search)
    let currentLang = searchParams.get('language');

    // Set default language if no language is given in url
    // TODO Medium: Get fallback language from config - will not always be NL;
    if(!currentLang)
        currentLang = $('.langSwitch').data('default') || $('html').attr('lang');

    // Trigger language
    changeFlagIcon(currentLang);
    changeLanguage(currentLang);

    // Change the current flag on the listener.
    $('.langSwitch .dropdown-item').on('click', (event) => {
        // Get search parameters
        let searchParams = new URLSearchParams( $(event.currentTarget).attr('href') );
        let currentLang = searchParams.get('language');

        // Show current flag icon and current language fields
        changeFlagIcon(currentLang);
        changeLanguage(currentLang);

        // Close dropdown
        $(event.currentTarget)
            .parents('.dropdown-menu')
            .removeClass('show')
                .parents('.dropdown')
                .removeClass('show')
                .find('.dropdown-toggle')
                    .attr('aria-expanded', false)
                    .end();

        return false;
    });

    // Switch flag icon dropdown
    function changeFlagIcon(currentLang)
    {
        // Get relevant dropdown item by hash.
        let dropdownItem = $('.langSwitch .dropdown-item[href$="language=' + currentLang + '"]') || $('.langSwitch .dropdown-item:first-child');

        // Update icon if language is found.
        if( dropdownItem )
            $('.langSwitch .dropdown-toggle').html( dropdownItem.find('i').clone() );
    }

    // Function to check current language
    function changeLanguage(currentLang)
    {
        // Get all language Fields
        let $langFields = $('*[data-lang]');

        $langFields.each(function (index, value)
        {
            // Check if language field shave current (SET) language
            if( $(value).data('lang') == currentLang)
                $(value).show();
            else
                $(value).hide();

            // If language is empty; show as well
            if( $(value).data('lang') === '' || currentLang === '' )
                $(value).show();
        });

        // Change in canvas editors.
        $('.galaxy\\:\\:common-canvas-Editor:not(.view)')
           .each((i, element) =>
           {
               // Get Vue instance.
               let vueInstance = $(element).data('vueInstance');

               // Set new language. Reactivity will trigger update.
               vueInstance.currentLanguage = currentLang;
           })
    }

});